import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification-panel is-warning"
}
const _hoisted_2 = { class: "width-wrap" }
const _hoisted_3 = { class: "flashmessage flash-warning" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "width-wrap" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = {
  key: 5,
  class: "header-addon"
}
const _hoisted_12 = {
  key: 0,
  class: "company-logo"
}
const _hoisted_13 = {
  key: 6,
  class: "header-addon"
}
const _hoisted_14 = { class: "contact-person contact-person--inline" }
const _hoisted_15 = { class: "contact-person__photo" }
const _hoisted_16 = { class: "contact-person__info" }
const _hoisted_17 = { class: "contact-person__name" }
const _hoisted_18 = {
  key: 0,
  class: "company-logo"
}
const _hoisted_19 = { class: "page-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AdOfferList = _resolveComponent("AdOfferList", true)!

  return (_openBlock(), _createElementBlock("div", {
    id: "body",
    class: _normalizeClass(["template_offerlist fullwidth", { 'list-history': _ctx.isHistory }])
  }, [
    (_ctx.isUserList && !_ctx.user.isEmailConfirmed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t('AdOfferList.confirm-email-message')) + " ", 1),
              (!_ctx.isConfirmEmailSent)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "button button--warning reversed",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendConfirmEmail && _ctx.sendConfirmEmail(...args)))
                  }, _toDisplayString(_ctx.$t('AdOfferList.button-send-confirm-email')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('AdOfferList.confirm-email-success', { email: _ctx.user.email })), 1))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["page-header", { 'has-addon': _ctx.headerHasAddon, 'has-button': _ctx.isDeveloperProject }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isUserList)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_ctx.$t('AdOfferList.titles.user')), 1))
          : (_ctx.isFavorite)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_7, _toDisplayString(_ctx.$t('AdOfferList.titles.favorite')), 1))
            : (_ctx.isHistory)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_8, _toDisplayString(_ctx.$t('AdOfferList.titles.history')), 1))
              : (_ctx.isDeveloperProject)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(_ctx.$t('AdOfferList.titles.developer-project')), 1))
                : (_openBlock(), _createElementBlock("h1", _hoisted_10, [
                    _createTextVNode(_toDisplayString(_ctx.$t('AdOfferList.titles.default')) + " ", 1),
                    (_ctx.estateAgency && !_ctx.estateAgent)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("- " + _toDisplayString(_ctx.estateAgency.title), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.estateAgent)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("- " + _toDisplayString(_ctx.estateAgent.fullName), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])),
        (_ctx.estateAgency)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (!_ctx.isEstateAgencyMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_ResizableImage, {
                      classes: "estate-agency-logo",
                      url: _ctx.estateAgency.logoRelativeUrl,
                      placeholder: "img/no-logo-agency.png",
                      width: 240,
                      height: 135,
                      alt: "estateAgency.title"
                    }, null, 8, ["url"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.estateAgent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_ResizableImage, {
                    url: _ctx.estateAgent.photoRelativeUrl,
                    placeholder: "img/no-photo-user.png",
                    width: 43,
                    height: 43,
                    alt: _ctx.estateAgent.fullName
                  }, null, 8, ["url", "alt"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.estateAgent.fullName), 1)
                ])
              ]),
              (!_ctx.isEstateAgencyMode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_router_link, {
                      to: { name: 'AdAgencyList', params: { urlName: _ctx.estateAgent.estateAgencyUrlName } }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ResizableImage, {
                          classes: "estate-agency-logo",
                          url: _ctx.estateAgent.logoRelativeUrl,
                          placeholder: "img/no-logo-agency.png",
                          width: 240,
                          height: 135,
                          alt: "agency"
                        }, null, 8, ["url"])
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDeveloperProject)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 7,
              to: { name: 'AdDeveloperProjectFormCreate' },
              tag: "button",
              class: "button button--primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('AdOfferList.developer-project.button')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_AdOfferList, {
        mode: _ctx.mode,
        estateAgencyId: _ctx.estateAgencyId,
        frontUserId: _ctx.frontUserId
      }, null, 8, ["mode", "estateAgencyId", "frontUserId"])
    ])
  ], 2))
}